module.exports = "https://coursera_assets.s3.amazonaws.com/images/e3e02529f1f40b93e0b8fd1901177ebb.png";